import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
    const locales = require.context(
        "./i18n",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const i18n = createI18n({
    legacy: false, // Включение режима нового API (рекомендуется для версии 9.x)
    locale: "en", // Язык по умолчанию
    fallbackLocale: "en", // Язык, который будет использоваться, если выбранный не найден
    messages: loadLocaleMessages(),
    warnHtmlInMessage: false,
});

export default i18n;
